import { render, staticRenderFns } from "./CustomVideo.vue?vue&type=template&id=a16fa278&scoped=true"
import script from "./CustomVideo.vue?vue&type=script&lang=js"
export * from "./CustomVideo.vue?vue&type=script&lang=js"
import style0 from "./CustomVideo.vue?vue&type=style&index=0&id=a16fa278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16fa278",
  null
  
)

export default component.exports